import { PlayerInterface } from 'src/models/player';

export const getPlayersRTCValues = async (token): Promise<PlayerInterface[]> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/rtc_values_with_offsets`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();

    if (response.ok) {
      return data;
    } else {
      console.log('Error fetching players RTC values', data);
      throw new Error('Failed to fetch players RTC values');
    }
  } catch (error) {
    console.error('Error fetching players RTC values', error);
    throw error;
  }
};
